"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/**
 * A generic event bus utility for JavaScript.
 */
var instance = null;

var EventBus = /*#__PURE__*/function () {
  function EventBus() {
    (0, _classCallCheck2["default"])(this, EventBus);

    if (!instance) {
      instance = this;
    } // Create a map of event names to arrays of subscribers.


    this.subscribers = new Map(); // Create a map of most recent event data for each event name.

    this.mostRecentEventData = new Map();
    return instance;
  }
  /**
   * Subscribe to an event.
   * @param {string} eventName The name of the event to subscribe to.
   * @param {Function} callback The function to call when the event is published.
   * @param {boolean} getMostRecentEventData Whether to immediately call the callback with the most recent event data.
   * @param {boolean} getImmediateEventData Whether to immediately call the callback with the most recent event data even if it's undefined.
   * @returns {{ unsubscribe: Function }} An object with an "unsubscribe" method that can be used to unsubscribe from the event.
   */


  (0, _createClass2["default"])(EventBus, [{
    key: "subscribe",
    value: function subscribe(eventName, callback) {
      var getMostRecentEventData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var getImmediateEventData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      // Add the subscriber to the array of subscribers for the event name.
      if (!this.subscribers.has(eventName)) {
        this.subscribers.set(eventName, []);
      }

      var subscribers = this.subscribers.get(eventName);
      var subscriber = {
        callback: callback
      };
      subscribers.push(subscriber); // Call the callback with the most recent event data, if requested.

      if (getMostRecentEventData) {
        var mostRecentEventData = this.mostRecentEventData.get(eventName);

        if (mostRecentEventData !== undefined || getImmediateEventData) {
          callback(mostRecentEventData);
        }
      } // Return an object with an "unsubscribe" method that can be used to unsubscribe from the event.


      return {
        unsubscribe: function unsubscribe() {
          var index = subscribers.indexOf(subscriber);

          if (index !== -1) {
            subscribers.splice(index, 1);
          }
        }
      };
    }
    /**
     * Publish an event.
     * @param {string} eventName The name of the event to publish.
     * @param {*} eventData The data to pass to the subscribers.
     */

  }, {
    key: "publish",
    value: function publish(eventName, eventData) {
      // Set the most recent event data for the event name.
      this.mostRecentEventData.set(eventName, eventData);
      this.mostRecentEventData.set(eventName, eventData); // Call each subscriber's callback with the event data.

      var subscribers = this.subscribers.get(eventName);

      if (subscribers) {
        subscribers.forEach(function (subscriber) {
          return subscriber.callback(eventData);
        });
      }
    }
  }]);
  return EventBus;
}();
/**
 * global variable to share the single instance of the function across different packages.
 */


global.eventBus = global.eventBus || new EventBus();
var _default = global.eventBus;
exports["default"] = _default;